// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2-Tpr","disabled":"FileBtn_disabled__1CcZK","warn":"FileBtn_warn__2uL3U","fade":"FileBtn_fade__yfcmp"};